import { initialMessagesState } from "./messages/messagesState";
// import { IAutomobilePolicyRiskLocationState, defaultAutomobilePolicyRiskLocationState } from "./automobilePolicyRiskLocation/automobilePolicyRiskLocation.types";
import { defaultCommonState } from "./common/common.types";

import { initialUserProfileState } from "./UserProfileList/userprofileState";

import { defaultDataManagementState } from "./DataManagement/defaultState";
import { defaultApprovalQuoteState } from "./approval/quote/defaultState";
import { defaultCommentState } from "./comments";
import { initialCompanyState } from "./company/company.types";
import { initialContactState } from "./contacts/contacts.types";

import { defaultCostingSheetState } from "./costingSheet/defaultState";
import { defaultCustomerState } from "./customer";
import { initialHistoryState } from "./history";
import { initialManageSiteState } from "./manageSite/defaultState";
import { inititalOpportunityState } from "./opportunites/opportunites.types";
import { initialProductsState } from "./products/products.types";
import { initialProjectState } from "./projects/defaultState";
import { defaultQuoteState } from "./quote/defaultState";
import { defaultRenderingState } from "./rendering/defaultState";
import { initialScheduleTaskState } from "./scheduleTask/defaultState";
import { initialSecurityState } from "./security/security.types";
import { initialTaskBoardState } from "./taskBoard/taskBoard.types";
import { initialTaskCalenderState } from "./taskCalender/tasksCalender.types";
import { initialTaskCategoryState } from "./taskCategory/defaultState";
import { initialTaskListState } from "./taskList/defaultState";
import { defaultProjectTeamState } from "./projectTeam/defaultState";
import { defaultExpenseModuleState } from "./expenseModule/defaultState";
import { defaultDepartmentState } from "./department/defaultState";
import { defaultJobCustomerState } from "./job_customer";
import { initialJobCustomerBranchState } from "./customerBranch";
import { initialCustomerDeliveryAddressState } from "./customerDeliveryAddress";
import { initialCustomerDispatchAddressState } from "./customerDispatchAddress";
import { defaultCustomerVendorAttachmentState } from "./customerVendorAttachment";
import { initialBankDetailsState } from "./bankDetails/defaultState";
import { initialJobContactState } from "./job_contacts";
import { defaultBillingCompanyState } from "./billingCompany";
import { initialVendorState } from "./vendor";
import { defaultPurchaseOrderState } from "./purchase-order";
import { defaultQuotationState } from "./quotation";
import { defaultSaleOrderState } from "./sale-order";
import { defaultInvoiceState } from "./invoice";
import { initialJobsState } from "./jobs/defaultState";
import { defaultUserDocumentState } from "./userDocument/userDocument.state";
import { deafaultDraftState } from "./draft";
import { defaultVendorPaymentState } from "./expenseModule/vendor-payments/vendor-payments.state";
import { defaultAnalyticsState } from "./analytics";
import { initialStatusState } from "./status/status.types";
import { initialMasterCategoriesState } from "./masterCategories/masterCategories.types";
import { defaultGateEntryState } from "./gate-entry";
import { defaultGoodsReceivedNoteState } from "./grn";
import { defaultPurchaseInvoiceState } from "./purchase-invoice";
import { defaultServiceInvoiceState } from "./service-invoice";
import { defaultServiceRequesitionState } from "./service-request/service-request.state";
import { defaultServiceOrderState } from "./service-order";
import { defaultLedgerState } from "./ledger";
import { defaultMaterialRequestState } from "./MaterialRequest";
import { initialBomState } from "./bom/defaultState";
import { initialDistinctRecordState } from "./distinctRecord/distinctrecord.state";
import { initialDrawingState } from "./drawing/defaultState";
import { defaultDrawingItemState } from "./drawingItem/defaultState";
import { defaultMRPAllocationState } from "./mrp-allocations/mrp-allocations.state";
import { defaultBdlState } from "./bdl/defaultState";
import { defaultInternalStoreTransferState } from "./internal-store-transfer";
import { IStoreState } from "./store.types";
import { defaultApprovalHistoryState } from "./approval/approval-history/approval-history.state";

export const initialStoreState: IStoreState = {
  customizerReducer: {
    activeDir: "ltr",
    activeNavbarBg: "#0b70fb", // This can be any color,
    activeSidebarBg: "#ffffff", // This can be any color
    activeMode: "light", // This can be light or dark
    // activeTheme: "BLACK_THEME", // BLUE_THEME, GREEN_THEME, RED_THEME, BLACK_THEME, PURPLE_THEME, INDIGO_THEME
    activeTheme: "ROCKWORTH_THEME", // BLUE_THEME, GREEN_THEME, RED_THEME, BLACK_THEME, PURPLE_THEME, INDIGO_THEME
    SidebarWidth: 240,
    sidebarOpen:
      typeof window !== "undefined" ? window.innerWidth >= 1200 : true,
  },

  customer: defaultCustomerState,
  message: initialMessagesState,

  common: defaultCommonState,
  analytics: defaultAnalyticsState,
  userprofile: initialUserProfileState,
  vendorExpense: defaultVendorPaymentState,
  opportunites: inititalOpportunityState,
  company: initialCompanyState,
  contacts: initialContactState,
  products: initialProductsState,
  quotes: defaultQuoteState,
  costingSheet: defaultCostingSheetState,
  taskBoard: initialTaskBoardState,
  security: initialSecurityState,
  rendering: defaultRenderingState,
  dataManagement: defaultDataManagementState,
  approvalQuotes: defaultApprovalQuoteState,
  comment: defaultCommentState,
  history: initialHistoryState,
  projects: initialProjectState,
  projectTeam: defaultProjectTeamState,
  scheduleTask: initialScheduleTaskState,
  taskList: initialTaskListState,
  taskCategory: initialTaskCategoryState,
  calender: initialTaskCalenderState,
  manageSite: initialManageSiteState,
  expenseModule: defaultExpenseModuleState,
  department: defaultDepartmentState,
  job_customer: defaultJobCustomerState,
  job_customerBranch: initialJobCustomerBranchState,
  customerDeliveryAddress: initialCustomerDeliveryAddressState,
  customerDispatchAddress: initialCustomerDispatchAddressState,
  customerVendorAttachment: defaultCustomerVendorAttachmentState,
  bankDetails: initialBankDetailsState,
  job_contacts: initialJobContactState,
  billingCompany: defaultBillingCompanyState,
  vendor: initialVendorState,
  purchase_order: defaultPurchaseOrderState,
  quotation: defaultQuotationState,
  sale_order: defaultSaleOrderState,
  invoices: defaultInvoiceState,
  jobs: initialJobsState,
  userDocument: defaultUserDocumentState,
  drafts: deafaultDraftState,
  status: initialStatusState,
  masterCategories: initialMasterCategoriesState,

  gateEntry: defaultGateEntryState,
  grn: defaultGoodsReceivedNoteState,
  purchaseInvoice: defaultPurchaseInvoiceState,
  serviceInvoice: defaultServiceInvoiceState,
  serviceRequesition: defaultServiceRequesitionState,
  serviceOrder: defaultServiceOrderState,
  ledger: defaultLedgerState,
  material_request: defaultMaterialRequestState,
  bom: initialBomState,
  distinctRecord: initialDistinctRecordState,
  drawing: initialDrawingState,
  drawingItem: defaultDrawingItemState,
  mrp_allocations: defaultMRPAllocationState,
  bdl: defaultBdlState,
  internalStoreTransfer: defaultInternalStoreTransferState,
  approvals: {
    history: defaultApprovalHistoryState,
  },
};
